import Vue from 'vue';
import Router from 'vue-router';
import CourseCertificate from '@/components/router-views/CourseCertificate.vue';
import PlaylistHome from '@/components/router-views/PlaylistMain.vue';
import PageNotFound from '@/components/router-views/PageNotFound.vue';
import Wellbeing from '@/components/router-views/Wellbeing.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/course/wellbeing/:courseHash?',
      name: 'Wellbeing',
      component: Wellbeing,
      title: 'Wellbeing Domain Check',
    },
    {
      path: '/course/certificate/:courseHash/:certificateHash',
      name: 'Course Certificate',
      component: CourseCertificate,
      title: 'Playposit Course Certificate',
    },
    {
      path: '/course/:courseHash',
      name: 'Initial Course Load',
      component: PlaylistHome,
      title: 'Playposit Interactive Course View',
    },
    {
      path: '/course/:courseHash/module/:moduleId/item/:itemId',
      name: 'Course Home',
      component: PlaylistHome,
      title: 'Playposit Interactive Course View',
    },
    {
      path: '*',
      name: '404',
      component: PageNotFound,
    },
  ],
});
